import { EActions } from "redux/actions/EActions";

export interface INewPasswordState {
  isRequestSent: boolean;
  error: string;
  isSending: boolean;
}

const initalState = {
  isRequestSent: false,
  isSending: false,
  error: "",
};

const reducer = (state: INewPasswordState = initalState, action: any) => {
  switch (action.type) {
    case EActions.NewPassword:
      return {
        ...state,
        isSending: true,
        isRequestSent: false,
        error: "",
      };
    case EActions.NewPasswordSuccess: {
      return {
        ...state,
        isSending: false,
        isRequestSent: true,
      };
    }
    case EActions.NewPasswordFail:
      return {
        ...state,
        isSending: false,
        error: action.payload,
      };
  }
  return state;
};

export default reducer;
